var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXZicnRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3974_2702",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#e33745"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3974_2702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11.75V10.25H15.75V11.75H8.25ZM8.25 7.75V6.25H15.75V7.75H8.25ZM6 14.25H13.5C13.9448 14.25 14.3563 14.3462 14.7345 14.5385C15.1128 14.7308 15.434 15.0026 15.698 15.3538L18 18.354V4.30775C18 4.21792 17.9712 4.14417 17.9135 4.0865C17.8558 4.02883 17.7821 4 17.6923 4H6.30775C6.21792 4 6.14417 4.02883 6.0865 4.0865C6.02883 4.14417 6 4.21792 6 4.30775V14.25ZM6.30775 20H17.3673L14.5173 16.2712C14.3916 16.1058 14.2419 15.9775 14.0682 15.8865C13.8946 15.7955 13.7052 15.75 13.5 15.75H6V19.6923C6 19.7821 6.02883 19.8558 6.0865 19.9135C6.14417 19.9712 6.21792 20 6.30775 20ZM17.6923 21.5H6.30775C5.80258 21.5 5.375 21.325 5.025 20.975C4.675 20.625 4.5 20.1974 4.5 19.6923V4.30775C4.5 3.80258 4.675 3.375 5.025 3.025C5.375 2.675 5.80258 2.5 6.30775 2.5H17.6923C18.1974 2.5 18.625 2.675 18.975 3.025C19.325 3.375 19.5 3.80258 19.5 4.30775V19.6923C19.5 20.1974 19.325 20.625 18.975 20.975C18.625 21.325 18.1974 21.5 17.6923 21.5Z",
    fill: "#e33745"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXZicnRed);
export default __webpack_public_path__ + "static/media/XZicnRed.7c7595ea086e82ebc585e63a027515b3.svg";
export { ForwardRef as ReactComponent };